// extracted by mini-css-extract-plugin
export default {"tooltip":"Wj6lO","tooltip_invert":"wtrx7","tooltip__content":"s4Y6T","tooltip__arrow":"b4ygA"};